import { Parser as HtmlToReactParser } from "html-to-react";
import * as HtmlToReact from "html-to-react";
import { AttentionBox } from "../AttentionBox";
import React from "react";

export const htmlToReact = htmlString => {
    let htmlToReactParser = new HtmlToReactParser();

    let processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    let isValidNode = function () {
        return true;
    };

    let processingInstructions = [
        {
            // This is REQUIRED, it tells the parser
            // that we want to insert our React
            // component as a child
            shouldProcessNode: function (node) {
                return node.attribs && node.attribs["data-container"] === "AttentionBox";
            },
            processNode: function (node, children, index) {
                const variant = node.attribs["data-container-variant"];
                const readMore = node.attribs["data-container-readmore"];
                const maxHeight = node.attribs["data-container-maxHeight"];
                return (
                    <AttentionBox
                        key={index}
                        message={children}
                        variant={variant}
                        readMore={readMore == null ? undefined : readMore === "true" ? true : false}
                        maxHeight={maxHeight == null ? undefined : parseFloat(maxHeight)}
                    />
                );
            }
        },
        {
            // Anything else
            shouldProcessNode: () => {
                return true;
            },
            processNode: processNodeDefinitions.processDefaultNode
        }
    ];

    let reactComponent = htmlToReactParser.parseWithInstructions(htmlString, isValidNode, processingInstructions);
    return reactComponent;
};
